const seperateAdminFromEuFields = (
  adminFieldsIds = [],
  euFieldsIds = [],
  values = {}
) => {
  const adminInput = {};
  const endUserInput = {};

  Object.entries(values).forEach(([fieldId, iv]) => {
    if (!!!iv && iv !== 0) {
      delete values[fieldId];
    }
  });

  adminFieldsIds.forEach(fId => (adminInput[fId] = values[fId]));
  euFieldsIds.forEach(fId => (endUserInput[fId] = values[fId]));

  return { adminInput, endUserInput };
};

export default seperateAdminFromEuFields;
